import { JSX } from 'react';
import type { AppProps } from 'next/app';
import Router from 'next/router';
import { I18nProvider } from 'next-localization';
import NProgress from 'nprogress';
import { ApolloProvider } from '@apollo/client';
import client from 'src/apollo/provider';
import '../assets/scss/main.scss';
import '../assets/scss/skeletons.scss';
import '../assets/scss/font.css';
import '../lib/customScripts';
import { FilterProvider } from 'components/context/FilterContext';
import { ThemeProvider } from 'components/context/ThemeContext';
import { FormTypeProvider } from 'components/context/FormContext';
import { SitecorePageProps } from 'lib/page-props';
import Bootstrap from 'src/Bootstrap';
// import { useLinksourceLinks } from 'src/hooks/useLinksourceLinks';

NProgress.configure({ showSpinner: false, trickleSpeed: 100 });

Router.events.on('routeChangeStart', () => NProgress.start());
Router.events.on('routeChangeComplete', () => NProgress.done());
Router.events.on('routeChangeError', () => NProgress.done());

function App({
  Component,
  pageProps,
}: AppProps<SitecorePageProps>): JSX.Element {
  const { dictionary, ...rest } = pageProps;
  // useLinksourceLinks();
  return (
    <>
      <Bootstrap {...pageProps} />
      <ApolloProvider client={client}>
        <I18nProvider lngDict={dictionary} locale={pageProps.locale}>
          <ThemeProvider>
            <FilterProvider>
              <FormTypeProvider>
                <Component {...rest} />
              </FormTypeProvider>
            </FilterProvider>
          </ThemeProvider>
        </I18nProvider>
      </ApolloProvider>
    </>
  );
}

export default App;
